import { Mail } from 'react-feather'

export default [
    {
        id: "emailTemplate",
        title: "Email Template",
        icon: <Mail size={20} />,
        badge: "light-warning",
        navLink: "/email-template",
        action: "manage",
        resource: "report-template"
    }
]